import React from "react";
import { Box, Grid } from "@mui/joy";
import DarkInput from "../../common/DarkInput";
import DarkTypography from "../../common/DarkTypography";
import type { Dispatch, SetStateAction } from "react";

type AddressComponentProps = {
  street: string | undefined;
  postalCode: string | undefined;
  city: string | undefined;
  setStreet: Dispatch<SetStateAction<string | undefined>>;
  setPostalCode: Dispatch<SetStateAction<string | undefined>>;
  setCity: Dispatch<SetStateAction<string | undefined>>;
};

export default function AddressComponent(props: AddressComponentProps) {
  const handlePostalCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.replace(/\D/g, "");
    props.setPostalCode(inputValue);
  };

  return (
    <Box sx={{ padding: 1 }}>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <Box sx={{ margin: "10px" }}>
            <DarkTypography level="h4" sx={{ marginBottom: "4px" }}>
              Numéro et rue
            </DarkTypography>
            <DarkInput
              placeholder="Numéro et rue"
              value={props.street || ""}
              onChange={(e) => props.setStreet(e.target.value)}
              sx={{ width: "100%" }}
            />
          </Box>
        </Grid>
        <Grid xs={6}>
          <Box sx={{ margin: "10px" }}>
            <DarkTypography level="h4" sx={{ marginBottom: "4px" }}>
              Code Postal
            </DarkTypography>
            <DarkInput
              placeholder="Code Postal"
              value={props.postalCode || ""}
              onChange={handlePostalCodeChange}
              type="number"
              sx={{ width: "100%" }}
            />
          </Box>
        </Grid>
        <Grid xs={6}>
          <Box sx={{ margin: "10px" }}>
            <DarkTypography level="h4" sx={{ marginBottom: "4px" }}>
              Ville
            </DarkTypography>
            <DarkInput
              placeholder="Ville"
              value={props.city || ""}
              onChange={(e) => props.setCity(e.target.value)}
              sx={{ width: "100%" }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
